import { push } from "services/NavigationService";

// PURE ACTIONS
export const setScreenWithRole = path => {
  return (dispatch, getState) => {
    if (path == "administrator" || path == "todden") {
      push(`/${path}`);
    } else if (path == "teacher") {
      push(`/${path}/classes`);
    }
  };
};

// ------------------------------------
// Reducer Handlers
// ------------------------------------
const REDUCER_HANDLERS = {};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
